define([
	"dojo/_base/declare",
	"dojo/query",
	"csi/action/_NewCommentMixin",
	"csi/action/EditController",
	"csi/heading/_base",
	"dojo/text!csi/widget/CommentDialogNode.html"
], function(declare,query,_NewCommentMixin,EditController,headingBase,template) {

	return declare([EditController, _NewCommentMixin], {
		preProcess: function() {
			// summary: popup comment dialog
			var	node = this.getNode();
			
			if (!this.widget.getOriginalComment(node)) {
				this.dialogTemplate = template;
			}
			
			this.edit(this.getTitle(), {
				subject: node.$Name,
				text: node.Comment
			});
		},
		
		preProcessContinue: function() {
			this.process();
		},
		
		toWriter: function() {
			// summary: send request
			this.toWriterComment();
		},

		postProcessSuccess: function() {
			// summary: refresh heading and update view
			var	view = this.widget;
			view.refreshHeading(view.defView.defsByKey.Date, this.m_urlNode);
			view.refreshHeading(view.defView.defsByKey.Comment, this.m_urlNode);
		}
	});
});